var Storage = {
  get: function get(key) {
    if (Storage.support) {
      return localStorage.getItem(key);
    }

    return null;
  },
  set: function set(key, value) {
    if (Storage.support) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {// window.console && window.console.log && console.log(e)
      }
    }
  },
  getJSON: function getJSON(key) {
    if (Storage.support) {
      try {
        return JSON.parse(Storage.get(key));
      } catch (e) {
        return null;
      }
    }
  },
  setJSON: function setJSON(key, value) {
    if (Storage.support) {
      try {
        value = JSON.stringify(value);
        Storage.set(key, value);
      } catch (e) {
        // window.console && window.console.log && console.log(e)
        return null;
      }
    }
  },
  remove: function remove(key) {
    if (Storage.support) {
      try {
        localStorage.removeItem(key);
      } catch (e) {// window.console && window.console.log && console.log(e)
      }
    }
  },
  support: function () {
    // 只检测localStorage 和 JSON， IE7不考虑了
    try {
      return typeof window.localStorage !== 'undefined' && !!localStorage.getItem && typeof JSON !== 'undefined';
    } catch (e) {
      return false;
    }
  }(),
  // 是否为safari无痕模式
  safariPrivateMode: false
}; // safari 无痕模式不支持localStorage.setItem

try {
  if (Storage.support) {
    localStorage.setItem('supportLocalStorageSetItem', 1);
    localStorage.removeItem('supportLocalStorageSetItem');
  } else {
    Storage.safariPrivateMode = true;
  }
} catch (e) {
  Storage.safariPrivateMode = true;
}

export default Storage;